import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = {
  key: 0,
  class: "product-card__missing-finish-cover"
}
const _hoisted_3 = { class: "product-card__img-wrap" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "product-card__quickship"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: "//images.baldwinhardware.com/is/image/Baldwin/quick-ship-small?scl=1&fmt=png-alpha",
  class: "product-card__quickship-img"
}, null, -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "product-card__text-content" }
const _hoisted_13 = { class: "product-card__title" }
const _hoisted_14 = {
  key: 0,
  class: "product-card__model-number"
}
const _hoisted_15 = {
  key: 0,
  class: "product-card__in-comparison"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "icon-compare-selected" }, null, -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "In Comparison Tray", -1 /* HOISTED */)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = ["checked", "id", "disabled"]
const _hoisted_20 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(["product-card", 'product-card--' + $props.portfolioType]),
    href: $props.url
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([$props.isFinishImageMissing ? `missing-finish` : ``, `product-card__visual-content`])
    }, [
      ($props.isFinishImageMissing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.translations.NoVariantImage), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_3, [
        ($options.availabilitySlug !== _ctx.avblActive)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["corner-badge", [$options.availabilitySlug ? `corner-badge--${$options.availabilitySlug}` : ``, $props.portfolioType ? `corner-badge--${$props.portfolioType}` : ``]])
            }, [
              _createElementVNode("span", null, _toDisplayString($props.availability), 1 /* TEXT */)
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        ($props.beautyImageUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: $props.beautyImageUrl + `?$bal%2Dproduct$`,
              alt: "product image",
              class: "product-card__img-beauty"
            }, null, 8 /* PROPS */, _hoisted_4))
          : _createCommentVNode("v-if", true),
        ($props.imageUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 2,
              src: $props.imageUrl + `?$bal%2Dproduct$`,
              alt: "product image",
              class: "product-card__img"
            }, null, 8 /* PROPS */, _hoisted_5))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["product-card__favorite-heart icon-whiteheart", _ctx.addedToFavorites ? 'state-favorited' : '']),
        title: "Add to Favorites",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.addremoveFavorites($event, $props.product)))
      }, _hoisted_8, 2 /* CLASS */),
      ($props.hasQuickship)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, _toDisplayString($props.title), 1 /* TEXT */),
      ($props.modelNumber)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Model: " + _toDisplayString($props.modelNumber), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (!$props.disableComparison)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            ($options.inComparisonItemsArray)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", {
              class: _normalizeClass(["product-card__compare", $options.maxCapacity ? 'disabled' : '']),
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.preventBubble($event)))
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                class: _normalizeClass($options.maxCapacity ? 'disabled' : ''),
                checked: $options.inComparisonItemsArray,
                id: `compare-${$props.index}`,
                disabled: $options.maxCapacity,
                onInput: _cache[1] || (_cache[1] = ($event: any) => ($options.addOrRemoveFromArray($props.product)))
              }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_19),
              _createElementVNode("label", {
                for: `compare-${$props.index}`,
                class: _normalizeClass([$options.maxCapacity ? 'disabled' : '', "m-0 pl-2"])
              }, " Compare", 10 /* CLASS, PROPS */, _hoisted_20)
            ], 2 /* CLASS */)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}